"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntheticStatsListSchema = exports.SyntheticStatsSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.SyntheticStatsSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: zod_1.z.string(),
    address: zod_1.z.string(),
    tokenIN: zod_1.z.string(),
    tokenOUT: zod_1.z.string(),
    tvl: core_contracts_ifaces_1.TokenAmountSchema,
    minRatioPercent: zod_1.z.number(),
    maxRatioPercent: zod_1.z.number(),
    minDurationSeconds: zod_1.z.number(),
    maxDurationSeconds: zod_1.z.number(),
});
exports.SyntheticStatsListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.SyntheticStatsSchema),
});
